import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReferenceQuestionQuery, ReferenceQuestionStoreModel } from '@examdojo/reference-question';
import { TopLevelFormGroup } from '@examdojo/question';
import { ReferenceQuestionService } from '@examdojo/reference-question';
import { catchError, distinctUntilChanged, EMPTY, filter, map, switchMap, tap } from 'rxjs';
import { SourceService } from '@examdojo/source';

@Injectable()
export class ReferenceQuestionEditorService {
  constructor(
    private readonly referenceQuestionQuery: ReferenceQuestionQuery,
    private readonly referenceQuestionService: ReferenceQuestionService,
    private readonly sourceService: SourceService,
  ) {
    this.fetchReferenceQuestionOnIdChange().pipe(takeUntilDestroyed()).subscribe();
  }

  readonly activeReferenceQuestionFetched$ = this.referenceQuestionQuery
    .selectActive()
    .pipe(map(Boolean), distinctUntilChanged());

  readonly referenceQuestionForm = new FormGroup({
    question_items: new FormArray<TopLevelFormGroup>([]),
    status: new FormControl<ReferenceQuestionStoreModel['status']>('NEEDS_QUESTION_INTERNAL_REVIEW', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  readonly questionItems$ = this.referenceQuestionQuery.questionItems$;

  private fetchReferenceQuestionOnIdChange() {
    return this.referenceQuestionQuery.selectActiveId().pipe(
      filter(Boolean),
      distinctUntilChanged(),
      switchMap((id) => this.referenceQuestionService.fetch(id).pipe(catchError(() => EMPTY))),
      tap((referenceQuestion) => {
        this.referenceQuestionForm.controls.status.setValue(referenceQuestion.status, {
          emitEvent: false,
        });
      }),
      switchMap((referenceQuestion) => {
        if (referenceQuestion.source_id) {
          return this.sourceService.fetch(referenceQuestion.source_id).pipe(catchError(() => EMPTY));
        }

        return EMPTY;
      }),
    );
  }
}
